/*
  Copies payment/trust icon groups (rendered once by sections/glimot-cart-icons.liquid) into the
  slots in the side drawer, add-to-cart pop-up and header cart preview:
    <div data-g-icons-slot="drawer|notification|preview" data-g-icons-position="checkout|view_cart">
  A group set to "Below 'View cart'" falls back to the "checkout" slot when no visible
  view_cart slot exists. Re-runs when those areas re-render after cart changes.
*/
(() => {
  const source = document.querySelector('[data-g-icons-source]');
  if (!source) return;
  const templates = [...source.querySelectorAll('template[data-g-icons-template]')];
  if (!templates.length) return;

  // A "View cart" button exists (the pop-up may still be closed, so don't test rendering).
  function isVisible(node) {
    return !!node && !node.hasAttribute('hidden');
  }

  function fill(area) {
    const slots = [...document.querySelectorAll(`[data-g-icons-slot="${area}"]`)];
    if (!slots.length) return;
    // Slots may exist in several places (e.g. drawer + preview): group them by container.
    const containers = new Set(slots.map((slot) => slot.closest('[data-g-icons-scope]') || slot.parentElement));
    containers.forEach((container) => {
      const local = slots.filter((slot) => container.contains(slot));
      const checkoutSlot = local.find((slot) => slot.dataset.gIconsPosition !== 'view_cart');
      const viewCartSlot = local.find((slot) => slot.dataset.gIconsPosition === 'view_cart');
      local.forEach((slot) => slot.replaceChildren());
      templates.forEach((template) => {
        const places = (template.dataset.places || '').split(' ');
        if (!places.includes(area)) return;
        let target = checkoutSlot;
        if (template.dataset.position === 'view_cart' && viewCartSlot && isVisible(viewCartSlot.previousElementSibling)) {
          target = viewCartSlot;
        }
        if (!target) target = viewCartSlot;
        if (target) target.append(template.content.cloneNode(true));
      });
    });
  }

  function fillAll() {
    fill('drawer');
    fill('notification');
    fill('preview');
  }

  fillAll();
  document.addEventListener('glimot:icons-refresh', fillAll);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => window.setTimeout(fillAll, 50));
  }

  // Cart drawer and pop-up re-render their inner HTML after changes; refill when that happens.
  const watch = (node) => {
    if (!node) return;
    let queued = false;
    new MutationObserver((mutations) => {
      // Ignore changes made by fill() itself inside the icon slots.
      const external = mutations.some((mutation) => !mutation.target.closest?.('[data-g-icons-slot]') && !mutation.target.matches?.('[data-g-icons-slot]'));
      if (!external || queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        fillAll();
      });
    }).observe(node, { childList: true, subtree: true });
  };
  watch(document.getElementById('CartDrawer'));
  watch(document.getElementById('cart-notification-links'));
  watch(document.getElementById('cart-notification-button'));
})();
